(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-logo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maison-chair-logo')) {
 customElements.define('maison-chair-logo',class extends HTMLElement {
  connectedCallback(){
   if(this.cleanup)return;
   const reduced=matchMedia('(prefers-reduced-motion: reduce)');
   const stop=()=>{clearTimeout(this.timer);cancelAnimationFrame(this.frame);this.classList.remove('is-alive');};
   const play=()=>{
    if(this.playedArrival||this.dataset.motion!=='true'||reduced.matches)return;
    this.playedArrival=true;this.classList.add('is-alive');
    this.timer=setTimeout(()=>this.classList.remove('is-alive'),5450);
   };
   const schedule=()=>{this.frame=requestAnimationFrame(()=>{this.frame=requestAnimationFrame(play);});};
   const onPageShow=event=>{
    if(event.persisted){stop();this.playedArrival=false;schedule();}
   };
   const onPreference=()=>{if(reduced.matches)stop();};
   window.addEventListener('pageshow',onPageShow);
   reduced.addEventListener('change',onPreference);
   schedule();
   this.cleanup=()=>{stop();window.removeEventListener('pageshow',onPageShow);reduced.removeEventListener('change',onPreference);this.cleanup=null;};
  }
  disconnectedCallback(){this.cleanup?.();}
 });
}
  } catch(e) { console.error(e); }
})();

})();
